import {
  Shift,
  ShiftsResponse,
  convertShift,
  convertStore,
} from '@nextforce/api'

export function convertShiftList(shifts: ShiftsResponse.Shift[]): Shift[] {
  return shifts.map(shift => {
    return convertShift(shift, convertStore(shift.store))
  })
}
